import editIcon from "@images/edit.png";
import infoIcon from "@images/info.png";
import trashIcon from "@images/trash.png";
import viewIcon from "@images/eye00f.png";
import exportIcon from "@images/export.png";
import downloadIcon from "@images/download00f.png";
import logInspection from "@images/logInspection.png";
import logActivity from "@images/logActivity.png";
import Accept from "@images/check.png";
import Cross from "@images/cross.png";
import deletes from "@images/delete.png";
import schedule from "@images/schedule.png";
import businessReport from "@images/businessReport.png";
import duplicateIcon from "@images/duplicateReport.png";
import replaceIcon from "@images/replace.png";
import {
  Button,
  Image,
  Overlay,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import _ from "lodash";
import { BsThreeDotsVertical } from "react-icons/bs";

const ToolTip = (props) => {
  let {
    show,
    setShow,
    options = [],
    id,
    index,
    isAction = false,
    // onHide
  } = props;

  const getImage = (name) => {
    if (name === "Edit") return editIcon;
    if (name === "Duplicate") return duplicateIcon;
    if (name === "View" || name === "Responses") return viewIcon;
    if (name === "Detail") return infoIcon;
    if (name === "Remove") return trashIcon;
    if (name === "Export") return exportIcon;
    if (name === "Download") return downloadIcon;
    if (name === "Log Activity") return logActivity;
    if (name === "Report Use") return businessReport;
    if (name === "Approve") return Accept;
    if (name === "Remove ") return deletes;
    if (name === "Reject") return Cross;
    if (name === "Log Inspection" || name === "Log Service")
      return logInspection;
    if (name === "Replace" || "Update") return replaceIcon;
    if (name === "Edit Schedule" || "Add Schedule") return schedule;
  };

  return (
    <OverlayTrigger
      trigger="click"
      as={Overlay}
      key={"placement"}
      placement={"bottom"}
      show={show}
      // onHide={onHide}
      rootClose
      overlay={
        <Popover id={`popover-positioned-bottom`}>
          <Popover.Body className="p-2 align-items-start">
            {options.map((option, ind) => {
              return (
                <a
                  key={`${id}-${ind}`}
                  className={`border-0 Bg-fff linkText${
                    option.disabled ? " disabled" : ""
                  }`}
                  style={
                    option.disabled
                      ? { opacity: 0.5, cursor: "not-allowed" }
                      : undefined
                  }
                  href={option.fileUrl}
                  onClick={(event) => {
                    if (option.disabled) {
                      event.preventDefault();
                      event.stopPropagation();
                      return;
                    }
                    option.onClick?.(event);
                  }}
                  aria-disabled={option.disabled}
                  tabIndex={option.disabled ? -1 : undefined}
                  role="button"
                  download
                  target="_blank"
                  rel="noreferrer"
                  id={`${id}.${_.camelCase(option.name)}`}
                >
                  {ind ? <hr className="mt-1 mb-1" /> : null}
                  {getImage(option.name) && (
                    <Image
                      src={getImage(option.name)}
                      alt="Icon"
                      className="editIcon"
                    />
                  )}
                  <strong className="C-link"> {option.name}</strong>
                </a>
              );
            })}
          </Popover.Body>
        </Popover>
      }
    >
      {isAction ? (
        <Button
          style={{
            border: "1px solid #c60970",
            backgroundColor: "transparent",
          }}
          size="sm"
          className="d-flex align-items-center justify-content-center ps-3"
          id={
            id
              ? `${id}${
                  index !== null || index !== undefined ? `.${index}` : ""
                }`
              : ""
          }
          onClick={setShow}
          disabled={options?.length > 0 ? false : true}
        >
          <span style={{ fontSize: "13px", fontWeight: 500, color: "#c60970" }}>
            Actions
          </span>
          <span className="C-primary ps-1">
            <BsThreeDotsVertical />
          </span>
        </Button>
      ) : (
        <button
          id={
            id
              ? `${id}${
                  index !== null || index !== undefined ? `.${index}` : ""
                }`
              : ""
          }
          onClick={setShow}
          disabled={options?.length > 0 ? false : true}
          className="edit-btn C-primary rounded-circle toolTip center"
        >
          <BsThreeDotsVertical />
        </button>
      )}
    </OverlayTrigger>
  );
};

export default ToolTip;
